var _path, _path2, _path3, _path4, _path5, _g, _g2, _path6, _path7, _path8, _path9, _path10, _g3, _g4, _path11, _path12, _path13, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg505(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 394,
    height: 134,
    viewBox: "0 0 394 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M124.127 3.95882C124.127 14.3168 124.084 58.3736 124.127 68.7316C124.127 68.7316 133.707 83.6677 167.676 83.6677C201.646 83.6677 211.226 68.7316 211.226 68.7316V4.35256C211.226 2.56565 210.992 1.03113 208.966 0.263868C206.855 -0.523582 205.688 0.67778 204.489 1.9801C200.755 6.0284 197.01 10.0666 193.01 14.3875C189.902 10.3392 186.974 6.52309 184.046 2.71708C181.277 -0.876925 179.155 -0.887022 176.45 2.6666C173.628 6.37166 170.816 10.0868 167.878 13.9635C164.727 9.98584 161.682 6.15966 158.648 2.32335C156.176 -0.79616 154.373 -0.775969 151.901 2.39402C148.845 6.31109 145.78 10.218 142.555 14.3471C139.043 10.6421 135.637 7.04806 132.221 3.44396C131.659 2.84831 131.097 2.25269 130.545 1.64696C129.41 0.405207 128.126 -0.31158 126.312 0.284057C124.413 0.909979 124.127 2.34355 124.127 3.95882Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M124.127 3.95882C124.127 14.3168 124.084 58.3736 124.127 68.7316C124.127 68.7316 133.707 83.6677 167.676 83.6677C201.646 83.6677 211.226 68.7316 211.226 68.7316V4.35256C211.226 2.56565 210.992 1.03113 208.966 0.263868C206.855 -0.523582 205.688 0.67778 204.489 1.9801C200.755 6.0284 197.01 10.0666 193.01 14.3875C189.902 10.3392 186.974 6.52309 184.046 2.71708C181.277 -0.876925 179.155 -0.887022 176.45 2.6666C173.628 6.37166 170.816 10.0868 167.878 13.9635C164.727 9.98584 161.682 6.15966 158.648 2.32335C156.176 -0.79616 154.373 -0.775969 151.901 2.39402C148.845 6.31109 145.78 10.218 142.555 14.3471C139.043 10.6421 135.637 7.04806 132.221 3.44396C131.659 2.84831 131.097 2.25269 130.545 1.64696C129.41 0.405207 128.126 -0.31158 126.312 0.284057C124.413 0.909979 124.127 2.34355 124.127 3.95882Z",
    fill: "url(#paint0_linear_513_3142)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M153.327 133.682C149.661 128.532 146.221 123.701 142.781 118.87C140.245 115.313 137.746 115.161 134.808 118.424C131.506 122.095 128.242 125.792 124.689 129.769C124.551 128.851 124.388 128.29 124.388 127.716C124.388 108.099 124.023 88.4681 124.551 68.863C125.015 51.3357 133.39 37.8621 148.23 29.1558C165.417 19.073 186.999 23.7768 200.182 39.7487C207.64 48.7736 211.406 59.1753 211.419 70.9408C211.444 89.4498 211.419 107.971 211.419 126.48C211.419 127.36 211.419 128.239 211.419 129.794C207.79 125.626 204.651 121.98 201.463 118.386C198.512 115.059 196.202 115.186 193.578 118.819C190.038 123.688 186.51 128.583 182.806 133.695C179.178 128.685 175.725 123.867 172.235 119.061C169.322 115.046 166.823 115.071 163.911 119.099C160.471 123.841 157.031 128.583 153.327 133.682Z",
    fill: "#1C1D23"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M153.327 133.682C149.661 128.532 146.221 123.701 142.781 118.87C140.245 115.313 137.746 115.161 134.808 118.424C131.506 122.095 128.242 125.792 124.689 129.769C124.551 128.851 124.388 128.29 124.388 127.716C124.388 108.099 124.023 88.4681 124.551 68.863C125.015 51.3357 133.39 37.8621 148.23 29.1558C165.417 19.073 186.999 23.7768 200.182 39.7487C207.64 48.7736 211.406 59.1753 211.419 70.9408C211.444 89.4498 211.419 107.971 211.419 126.48C211.419 127.36 211.419 128.239 211.419 129.794C207.79 125.626 204.651 121.98 201.463 118.386C198.512 115.059 196.202 115.186 193.578 118.819C190.038 123.688 186.51 128.583 182.806 133.695C179.178 128.685 175.725 123.867 172.235 119.061C169.322 115.046 166.823 115.071 163.911 119.099C160.471 123.841 157.031 128.583 153.327 133.682Z",
    fill: "url(#paint1_radial_513_3142)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M153.327 133.682C149.661 128.532 146.221 123.701 142.781 118.87C140.245 115.313 137.746 115.161 134.808 118.424C131.506 122.095 128.242 125.792 124.689 129.769C124.551 128.851 124.388 128.29 124.388 127.716C124.388 108.099 124.023 88.4681 124.551 68.863C125.015 51.3357 133.39 37.8621 148.23 29.1558C165.417 19.073 186.999 23.7768 200.182 39.7487C207.64 48.7736 211.406 59.1753 211.419 70.9408C211.444 89.4498 211.419 107.971 211.419 126.48C211.419 127.36 211.419 128.239 211.419 129.794C207.79 125.626 204.651 121.98 201.463 118.386C198.512 115.059 196.202 115.186 193.578 118.819C190.038 123.688 186.51 128.583 182.806 133.695C179.178 128.685 175.725 123.867 172.235 119.061C169.322 115.046 166.823 115.071 163.911 119.099C160.471 123.841 157.031 128.583 153.327 133.682Z",
    fill: "url(#paint2_radial_513_3142)",
    fillOpacity: 0.9
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter0_di_513_3142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.755 66.8442L159.192 63.351C159.78 62.7537 160.083 61.9665 160.083 61.1791C160.083 60.3917 159.789 59.6043 159.192 59.0072C158.008 57.8036 156.093 57.8036 154.909 59.0072L151.472 62.5002L148.034 59.0072C146.85 57.8036 144.936 57.8036 143.751 59.0072C143.163 59.6043 142.861 60.3917 142.861 61.1791C142.861 61.9665 143.155 62.7537 143.751 63.351L147.189 66.8442L143.751 70.3375C143.163 70.9348 142.861 71.7222 142.861 72.5094C142.861 73.2968 143.155 74.0842 143.751 74.6815C144.348 75.2786 145.114 75.5863 145.888 75.5863C146.663 75.5863 147.438 75.2878 148.026 74.6815L151.463 71.1882L154.9 74.6815C155.488 75.2786 156.262 75.5863 157.037 75.5863C157.812 75.5863 158.587 75.2878 159.174 74.6815C159.762 74.0751 160.065 73.2968 160.065 72.5094C160.065 71.7222 159.771 70.9348 159.174 70.3375L155.737 66.8442H155.755Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    filter: "url(#filter1_di_513_3142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.459 66.8442L192.896 63.351C193.484 62.7537 193.786 61.9665 193.786 61.1791C193.786 60.3917 193.492 59.6043 192.896 59.0072C191.712 57.8036 189.797 57.8036 188.613 59.0072L185.175 62.5002L181.738 59.0072C180.554 57.8036 178.639 57.8036 177.455 59.0072C176.867 59.6043 176.564 60.3917 176.564 61.1791C176.564 61.9665 176.858 62.7537 177.455 63.351L180.892 66.8442L177.455 70.3375C176.867 70.9348 176.564 71.7222 176.564 72.5094C176.564 73.2968 176.858 74.0842 177.455 74.6815C178.052 75.2786 178.817 75.5863 179.592 75.5863C180.367 75.5863 181.142 75.2878 181.729 74.6815L185.167 71.1882L188.604 74.6815C189.191 75.2786 189.966 75.5863 190.741 75.5863C191.516 75.5863 192.29 75.2878 192.878 74.6815C193.466 74.0751 193.768 73.2968 193.768 72.5094C193.768 71.7222 193.475 70.9348 192.878 70.3375L189.441 66.8442H189.459Z",
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M241.449 3.95882C241.449 14.3168 241.407 58.3736 241.449 68.7316C241.449 68.7316 251.029 83.6677 284.999 83.6677C318.968 83.6677 328.548 68.7316 328.548 68.7316V4.35256C328.548 2.56565 328.314 1.03113 326.288 0.263868C324.177 -0.523582 323.01 0.67778 321.811 1.9801C318.077 6.0284 314.332 10.0666 310.332 14.3875C307.224 10.3392 304.296 6.52309 301.368 2.71708C298.599 -0.876925 296.477 -0.887022 293.772 2.6666C290.95 6.37166 288.139 10.0868 285.2 13.9635C282.049 9.98584 279.004 6.15966 275.97 2.32335C273.499 -0.79616 271.695 -0.775969 269.223 2.39402C266.168 6.31109 263.102 10.218 259.877 14.3471C256.365 10.6421 252.96 7.04806 249.543 3.44396C248.981 2.84831 248.419 2.25269 247.867 1.64696C246.732 0.405207 245.449 -0.31158 243.635 0.284057C241.736 0.909979 241.449 2.34355 241.449 3.95882Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M241.449 3.95882C241.449 14.3168 241.407 58.3736 241.449 68.7316C241.449 68.7316 251.029 83.6677 284.999 83.6677C318.968 83.6677 328.548 68.7316 328.548 68.7316V4.35256C328.548 2.56565 328.314 1.03113 326.288 0.263868C324.177 -0.523582 323.01 0.67778 321.811 1.9801C318.077 6.0284 314.332 10.0666 310.332 14.3875C307.224 10.3392 304.296 6.52309 301.368 2.71708C298.599 -0.876925 296.477 -0.887022 293.772 2.6666C290.95 6.37166 288.139 10.0868 285.2 13.9635C282.049 9.98584 279.004 6.15966 275.97 2.32335C273.499 -0.79616 271.695 -0.775969 269.223 2.39402C266.168 6.31109 263.102 10.218 259.877 14.3471C256.365 10.6421 252.96 7.04806 249.543 3.44396C248.981 2.84831 248.419 2.25269 247.867 1.64696C246.732 0.405207 245.449 -0.31158 243.635 0.284057C241.736 0.909979 241.449 2.34355 241.449 3.95882Z",
    fill: "url(#paint3_linear_513_3142)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M270.65 133.682C266.984 128.532 263.544 123.701 260.104 118.87C257.568 115.313 255.069 115.161 252.131 118.424C248.829 122.095 245.565 125.792 242.012 129.769C241.874 128.851 241.711 128.29 241.711 127.716C241.711 108.099 241.347 88.4681 241.874 68.863C242.339 51.3357 250.713 37.8621 265.553 29.1558C282.741 19.073 304.322 23.7768 317.505 39.7487C324.963 48.7736 328.729 59.1753 328.742 70.9408C328.767 89.4498 328.742 107.971 328.742 126.48C328.742 127.36 328.742 128.239 328.742 129.794C325.114 125.626 321.975 121.98 318.786 118.386C315.836 115.059 313.525 115.186 310.901 118.819C307.361 123.688 303.833 128.583 300.129 133.695C296.501 128.685 293.048 123.867 289.558 119.061C286.645 115.046 284.147 115.071 281.234 119.099C277.794 123.841 274.354 128.583 270.65 133.682Z",
    fill: "#1C1D23"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M270.65 133.682C266.984 128.532 263.544 123.701 260.104 118.87C257.568 115.313 255.069 115.161 252.131 118.424C248.829 122.095 245.565 125.792 242.012 129.769C241.874 128.851 241.711 128.29 241.711 127.716C241.711 108.099 241.347 88.4681 241.874 68.863C242.339 51.3357 250.713 37.8621 265.553 29.1558C282.741 19.073 304.322 23.7768 317.505 39.7487C324.963 48.7736 328.729 59.1753 328.742 70.9408C328.767 89.4498 328.742 107.971 328.742 126.48C328.742 127.36 328.742 128.239 328.742 129.794C325.114 125.626 321.975 121.98 318.786 118.386C315.836 115.059 313.525 115.186 310.901 118.819C307.361 123.688 303.833 128.583 300.129 133.695C296.501 128.685 293.048 123.867 289.558 119.061C286.645 115.046 284.147 115.071 281.234 119.099C277.794 123.841 274.354 128.583 270.65 133.682Z",
    fill: "url(#paint4_radial_513_3142)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M270.65 133.682C266.984 128.532 263.544 123.701 260.104 118.87C257.568 115.313 255.069 115.161 252.131 118.424C248.829 122.095 245.565 125.792 242.012 129.769C241.874 128.851 241.711 128.29 241.711 127.716C241.711 108.099 241.347 88.4681 241.874 68.863C242.339 51.3357 250.713 37.8621 265.553 29.1558C282.741 19.073 304.322 23.7768 317.505 39.7487C324.963 48.7736 328.729 59.1753 328.742 70.9408C328.767 89.4498 328.742 107.971 328.742 126.48C328.742 127.36 328.742 128.239 328.742 129.794C325.114 125.626 321.975 121.98 318.786 118.386C315.836 115.059 313.525 115.186 310.901 118.819C307.361 123.688 303.833 128.583 300.129 133.695C296.501 128.685 293.048 123.867 289.558 119.061C286.645 115.046 284.147 115.071 281.234 119.099C277.794 123.841 274.354 128.583 270.65 133.682Z",
    fill: "url(#paint5_radial_513_3142)",
    fillOpacity: 0.9
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    filter: "url(#filter2_di_513_3142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.078 66.8442L276.515 63.351C277.103 62.7537 277.406 61.9665 277.406 61.1791C277.406 60.3917 277.112 59.6043 276.515 59.0072C275.331 57.8036 273.416 57.8036 272.232 59.0072L268.795 62.5002L265.357 59.0072C264.173 57.8036 262.259 57.8036 261.074 59.0072C260.486 59.6043 260.184 60.3917 260.184 61.1791C260.184 61.9665 260.478 62.7537 261.074 63.351L264.512 66.8442L261.074 70.3375C260.486 70.9348 260.184 71.7222 260.184 72.5094C260.184 73.2968 260.478 74.0842 261.074 74.6815C261.671 75.2786 262.437 75.5863 263.211 75.5863C263.986 75.5863 264.761 75.2878 265.349 74.6815L268.786 71.1882L272.223 74.6815C272.811 75.2786 273.585 75.5863 274.36 75.5863C275.135 75.5863 275.91 75.2878 276.497 74.6815C277.085 74.0751 277.388 73.2968 277.388 72.5094C277.388 71.7222 277.094 70.9348 276.497 70.3375L273.06 66.8442H273.078Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter3_di_513_3142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306.781 66.8442L310.218 63.351C310.806 62.7537 311.109 61.9665 311.109 61.1791C311.109 60.3917 310.815 59.6043 310.218 59.0072C309.034 57.8036 307.119 57.8036 305.935 59.0072L302.498 62.5002L299.061 59.0072C297.876 57.8036 295.962 57.8036 294.777 59.0072C294.19 59.6043 293.887 60.3917 293.887 61.1791C293.887 61.9665 294.181 62.7537 294.777 63.351L298.215 66.8442L294.777 70.3375C294.19 70.9348 293.887 71.7222 293.887 72.5094C293.887 73.2968 294.181 74.0842 294.777 74.6815C295.374 75.2786 296.14 75.5863 296.915 75.5863C297.689 75.5863 298.464 75.2878 299.052 74.6815L302.489 71.1882L305.926 74.6815C306.514 75.2786 307.289 75.5863 308.063 75.5863C308.838 75.5863 309.613 75.2878 310.201 74.6815C310.788 74.0751 311.091 73.2968 311.091 72.5094C311.091 71.7222 310.797 70.9348 310.201 70.3375L306.763 66.8442H306.781Z",
    fill: "white"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M46.1561 127.945C26.4005 127.945 11.0152 121.959 0 109.986L14.188 92.2058C22.5692 100.946 33.1653 105.316 45.9764 105.316C52.8011 105.316 58.1889 103.64 62.14 100.288C66.2109 96.8155 68.2463 92.565 68.2463 87.5364C68.2463 82.1485 66.3306 77.8382 62.4992 74.6055C58.6679 71.3728 53.3997 69.7564 46.6948 69.7564C36.7572 69.7564 28.3761 72.9891 21.5515 79.4546L3.77151 74.7851V6H86.0262V28.4494H29.2741V57.7235C35.979 51.0186 44.7792 47.6662 55.6746 47.6662C66.3306 47.6662 75.3703 51.1982 82.7935 58.2623C90.3365 65.3264 94.108 74.7252 94.108 86.4588C94.108 99.1502 89.7379 109.267 80.9976 116.81C72.2573 124.234 60.6434 127.945 46.1561 127.945Z",
    fill: "#1C1D23"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M365.445 75.993L368.937 70.702L352.884 66.4591L380.39 63.9509L376.898 69.242L392.97 73.4869L365.445 75.993Z",
    fill: "#E46223"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M374.149 25.6146L365.578 23.6109L377.711 4L347.581 27.7483L356.152 29.7335L344 49.3444L374.149 25.6146Z",
    fill: "#E46223"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_513_3142",
    x: 135.053,
    y: 54.2007,
    width: 32.8373,
    height: 33.0967,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.90381
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.90381
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_513_3142"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_513_3142",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.60254,
    dy: -2.60254
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.60254
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_513_3142"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_di_513_3142",
    x: 168.757,
    y: 54.2007,
    width: 32.8373,
    height: 33.0967,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.90381
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.90381
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_513_3142"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_513_3142",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.60254,
    dy: -2.60254
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.60254
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_513_3142"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_di_513_3142",
    x: 252.376,
    y: 54.2007,
    width: 32.8373,
    height: 33.0967,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.90381
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.90381
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_513_3142"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_513_3142",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.60254,
    dy: -2.60254
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.60254
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_513_3142"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_di_513_3142",
    x: 286.079,
    y: 54.2007,
    width: 32.8373,
    height: 33.0967,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.90381
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.90381
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_513_3142"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_513_3142",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.60254,
    dy: -2.60254
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.60254
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_513_3142"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_513_3142",
    x1: 150.359,
    y1: 79.3376,
    x2: 255.803,
    y2: -25.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E46223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.587785,
    stopColor: "#E46223",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E46223",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_513_3142",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(145.185 133.695) rotate(-63.7478) scale(61.5521 63.5575)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1D23"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_513_3142",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(192.254 36.8429) rotate(112.753) scale(39.0642 40.2365)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1D23",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_513_3142",
    x1: 267.682,
    y1: 79.3376,
    x2: 373.125,
    y2: -25.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E46223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.587785,
    stopColor: "#E46223",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E46223",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_513_3142",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(262.508 133.695) rotate(-63.7478) scale(61.5521 63.5575)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1D23"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_513_3142",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(309.577 36.8429) rotate(112.753) scale(39.0642 40.2365)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1D23",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg505);
export default __webpack_public_path__ + "static/media/505.e256d8173a9673b0ce11079d1b614ab5.svg";
export { ForwardRef as ReactComponent };